import { Router } from '@angular/router';

export function navigateBasedOnPermissions(permissions: any[], router: Router): void {
  if (!permissions || permissions.length === 0) {
    router.navigate(['/dashboard']);
    return;
  }

  const findFirstViewablePath = (items: any[]): string | null => {
    for (const item of items) {
      if (item.isView) {
        return item.path || null;
      }

      if (item.subMenuItems && item.subMenuItems.length > 0) {
        const subItemPath = findFirstViewablePath(item.subMenuItems);
        if (subItemPath) {
          return subItemPath;
        }
      }
    }
    return null;
  };

  const firstViewablePath = findFirstViewablePath(permissions);
  router.navigate([firstViewablePath || '/dashboard']);
}
